
import { CalculoBolsaVacacionesModel } from '../models/calculoBolsaVacaciones.model';
import {
  HttpClient, HttpParams
} from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IServiceBase } from './base/IServiceBase';
import { CalculoDiasVacacionesModel } from '../models/calculoDiasVacaciones.model';
import { PageList } from '../models/pageList.model';

@Injectable()
export class CalculoDiasVacacionesService extends HttpClientBaseService implements IServiceBase<any> {
  constructor(_http: HttpClient) {
    super(_http, 'CalculoVacaciones/','', false);
  }
  getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<any>> {
    return this.getAll();
  }
  getAllModels(parentId?: any, params?: HttpParams): Observable<CalculoDiasVacacionesModel[]> {
    return this.get(`${super.getUrl}dias`);
  }
  getModel(id: any, parentId?: any): Observable<any> {
    return super.getSingle<any>(id);
  }
  patch?(id: string | number, entity: any, tType: new () => any, parentId?: string | number): Observable<any> {
    throw new Error('Method not implemented.');
  }


}
